<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" (click)="checkFormBeforeSubmit()">Zapisz i wyjdź</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a></app-navbar
>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset>
			<div class="form-floating mb-3">
				<input type="text" id="name" class="form-control" name="name" [(ngModel)]="data.name" required />
				<label for="name" class="form-label">Nazwa<small class="ms-2 text-danger">* wymagane</small></label>
			</div>
			<div class="form-floating mb-3">
				<input
					type="text"
					id="convenience"
					[className]="isEmpty ? 'form-control is-invalid' : 'form-control'"
					name="convenience"
					[(ngModel)]="data.convenience"
					(change)="isEmptyCheck()"
				/>
				<label for="convenience" class="form-label">Nazwa angielska</label>
				<div *ngIf="isEmpty" class="invalid-feedback">To pole nie może posiadać odstępów</div>
			</div>

			<div class="form-floating my-4">
				<div>
					<img class="w-50" [src]="data.multimedia.url" />
				</div>
			</div>
			<label class="btn btn-success me-4">
				<input class="d-none" type="file" (change)="onFileSelected($event)" />
				<i class="fa-solid fa-file-circle-plus"></i> Wgraj zdjęcie z pliku
			</label>
			<label class="btn btn-danger">
				<input class="d-none" type="button" value="Usuń zdjęcie" (click)="deleteImage()" />
				<i class="fas fa-trash"></i>Usuń zdjęcie</label
			>
		</fieldset>
	</form>
</div>
